import { useEffect, useRef } from "react";
import { AnimatePresence, motion } from "framer-motion";

const LOGIN = { mp4: "/smart-scalper-intro-snd.mp4", webm: "/smart-scalper-intro-snd.webm" };
const LOGOUT = { mp4: "/smart-scalper-logout-snd.mp4", webm: "/smart-scalper-logout-snd.webm" };

export function AuthTransition({ active, mode }) {
  const isLogout = mode === "logout";
  const clip = isLogout ? LOGOUT : LOGIN;
  const videoRef = useRef(null);

  useEffect(() => {
    if (!active) return;
    const v = videoRef.current;
    if (!v) return;
    v.muted = false;
    v.volume = 1;
    try { v.currentTime = 0; } catch { /* ignore */ }
    const p = v.play();
    if (p && p.catch) {
      p.catch(() => {
        // Autoplay WITH sound blocked by the browser -> fall back to muted playback
        v.muted = true;
        v.play().catch(() => { /* first frame still shows */ });
      });
    }
  }, [active, isLogout]);

  return (
    <AnimatePresence>
      {active && (
        <motion.div
          key="auth-transition"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.4 }}
          className="fixed inset-0 z-[9999] flex items-center justify-center bg-black overflow-hidden"
          data-testid="auth-transition-overlay"
        >
          <video
            ref={videoRef}
            key={clip.mp4}
            data-testid="auth-transition-video"
            autoPlay
            playsInline
            preload="auto"
            className="h-full w-full object-contain"
          >
            <source src={clip.mp4} type="video/mp4" />
            <source src={clip.webm} type="video/webm" />
          </video>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
